export default __webpack_public_path__ + "media/images/react_icons/calendar_check_line-cabe53b4d297aa31699df38733b6701c.svg";